import {
    RefinementListItem,
    RefinementListRenderState
} from "instantsearch.js/es/connectors/refinement-list/connectRefinementList";
import { computed, ref } from "vue";


export type FilterCheckboxesProps = {
    state: RefinementListRenderState,
    searchable?: boolean,
}

function matches(item: RefinementListItem, term: string) {
    return item.label
        .normalize('NFD')
        .replace(/\p{Diacritic}/gu, '')
        .toLowerCase()
        .includes(
            term.normalize('NFD')
                .replace(/\p{Diacritic}/gu, '')
                .toLowerCase()
        );
}

export function useFilterCheckboxes(props: FilterCheckboxesProps) {
    const searchTerm = ref('');

    return {
        searchTerm,
        filteredItems: computed(() => {
            if (!props.searchable || !searchTerm.value) {
                return props.state.items;
            }
            return props.state.items.filter(item => matches(item, searchTerm.value));
        }),
    }
}
